<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import dingding from '@/assets/font/DingTalk JinBuTi.ttf'
export default {
  name: 'app',
  // components: {
  //   HelloWorld
  // }
}
</script>

<style lang="scss">
.vjs-custom-skin>.video-js{
  height: 480px !important;
}
html,
body,
p,
ul,
li {
  margin: 0;
  padding: 0;
  color: #333639;
}
.overf {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
ul,
li {
  list-style: none;
}
.app_content {
  background: url('https://hfy-img.xzyunchuang.com/3b7506a84d68c5204b9f83fe021ca337') repeat-x top left;
.wp {
  // background: url('https://hfy-img.xzyunchuang.com/ec83463d52d1466d0c2b9874be5bb2a5') no-repeat top center;
  background: url('https://hfy-img.xzyunchuang.com/44bceb3d65f7d0c9573027b99de05660') no-repeat top center;
  width: 100%;
  margin: 0 auto;

}
}
.font12{
  font-size: 12px;
}
.column_960{
  clear: both;
  margin: 0 auto;
  text-align: left;
  width: 960px;
}
.wptop {
  width: 960px;
  height: 403px;
  margin: 0 auto;
}

.menuBg {
  height: 54px;
  background: url('https://hfy-img.xzyunchuang.com/2ee32c4494bd64fe79d740200b4f8605') repeat-x top left;
  overflow: hidden;
  .menu {
        height: 54px;
        width: 960px;
        overflow: hidden;
        margin: 0 auto;
        color: #fff;

        li {
          color: #fff;
          display: inline-block;
          line-height: 54px;
          font-size: 14px;
          padding: 0 20px;
          position: relative;
          cursor: pointer;

          &::after {
            content: '';
            width: 2px;
            height: 96%;
            position: absolute;
            right: 0;
            top: 2%;
            background: linear-gradient(to right, #0e0e0e, #494949);
            box-shadow: 0px 0px 5px #424242;
          }

          &:hover {
            background: url('https://hfy-img.xzyunchuang.com/ece2396f22b904427aa71e922b759291');
            background-size: 100% 100%;
          }
        }
      }
}
</style>



// WEBPACK FOOTER //
// src/App.vue